const t = {
  "cdr-popup": "cdr-popup_15-6-1-beta-4",
  "cdr-popup--open": "cdr-popup--open_15-6-1-beta-4",
  "cdr-popup--closed": "cdr-popup--closed_15-6-1-beta-4",
  "cdr-popup__content": "cdr-popup__content_15-6-1-beta-4",
  "cdr-popup__arrow": "cdr-popup__arrow_15-6-1-beta-4",
  "cdr-popup--top": "cdr-popup--top_15-6-1-beta-4",
  "cdr-popup--bottom": "cdr-popup--bottom_15-6-1-beta-4",
  "cdr-popup--exit": "cdr-popup--exit_15-6-1-beta-4",
  "cdr-popup--corner-left": "cdr-popup--corner-left_15-6-1-beta-4",
  "cdr-popup--corner-right": "cdr-popup--corner-right_15-6-1-beta-4",
  "cdr-popup--left": "cdr-popup--left_15-6-1-beta-4",
  "cdr-popup--right": "cdr-popup--right_15-6-1-beta-4",
  "cdr-popup--corner-top": "cdr-popup--corner-top_15-6-1-beta-4",
  "cdr-popup--corner-bottom": "cdr-popup--corner-bottom_15-6-1-beta-4",
  "cdr-button": "cdr-button_15-6-1-beta-4",
  "cdr-button--has-icon-left": "cdr-button--has-icon-left_15-6-1-beta-4",
  "cdr-button--has-icon-right": "cdr-button--has-icon-right_15-6-1-beta-4",
  "cdr-button--primary": "cdr-button--primary_15-6-1-beta-4",
  "cdr-button--secondary": "cdr-button--secondary_15-6-1-beta-4",
  "cdr-button--dark": "cdr-button--dark_15-6-1-beta-4",
  "cdr-button--sale": "cdr-button--sale_15-6-1-beta-4",
  "cdr-button--link": "cdr-button--link_15-6-1-beta-4",
  "cdr-button--large": "cdr-button--large_15-6-1-beta-4",
  "cdr-button--medium": "cdr-button--medium_15-6-1-beta-4",
  "cdr-button--small": "cdr-button--small_15-6-1-beta-4",
  "cdr-button--icon-only": "cdr-button--icon-only_15-6-1-beta-4",
  "cdr-button--icon-only-large": "cdr-button--icon-only-large_15-6-1-beta-4",
  "cdr-button--with-background": "cdr-button--with-background_15-6-1-beta-4",
  "cdr-button--full-width": "cdr-button--full-width_15-6-1-beta-4",
  "cdr-button--small@xs": "cdr-button--small@xs_15-6-1-beta-4",
  "cdr-button--medium@xs": "cdr-button--medium@xs_15-6-1-beta-4",
  "cdr-button--large@xs": "cdr-button--large@xs_15-6-1-beta-4",
  "cdr-button--full-width@xs": "cdr-button--full-width@xs_15-6-1-beta-4",
  "cdr-button--small@sm": "cdr-button--small@sm_15-6-1-beta-4",
  "cdr-button--medium@sm": "cdr-button--medium@sm_15-6-1-beta-4",
  "cdr-button--large@sm": "cdr-button--large@sm_15-6-1-beta-4",
  "cdr-button--full-width@sm": "cdr-button--full-width@sm_15-6-1-beta-4",
  "cdr-button--small@md": "cdr-button--small@md_15-6-1-beta-4",
  "cdr-button--medium@md": "cdr-button--medium@md_15-6-1-beta-4",
  "cdr-button--large@md": "cdr-button--large@md_15-6-1-beta-4",
  "cdr-button--full-width@md": "cdr-button--full-width@md_15-6-1-beta-4",
  "cdr-button--small@lg": "cdr-button--small@lg_15-6-1-beta-4",
  "cdr-button--medium@lg": "cdr-button--medium@lg_15-6-1-beta-4",
  "cdr-button--large@lg": "cdr-button--large@lg_15-6-1-beta-4",
  "cdr-button--full-width@lg": "cdr-button--full-width@lg_15-6-1-beta-4",
  "cdr-icon": "cdr-icon_15-6-1-beta-4",
  "cdr-icon--small": "cdr-icon--small_15-6-1-beta-4",
  "cdr-icon--large": "cdr-icon--large_15-6-1-beta-4",
  "cdr-icon--small@xs": "cdr-icon--small@xs_15-6-1-beta-4",
  "cdr-icon--large@xs": "cdr-icon--large@xs_15-6-1-beta-4",
  "cdr-icon--small@sm": "cdr-icon--small@sm_15-6-1-beta-4",
  "cdr-icon--large@sm": "cdr-icon--large@sm_15-6-1-beta-4",
  "cdr-icon--small@md": "cdr-icon--small@md_15-6-1-beta-4",
  "cdr-icon--large@md": "cdr-icon--large@md_15-6-1-beta-4",
  "cdr-icon--small@lg": "cdr-icon--small@lg_15-6-1-beta-4",
  "cdr-icon--large@lg": "cdr-icon--large@lg_15-6-1-beta-4",
  "cdr-icon--inherit-color": "cdr-icon--inherit-color_15-6-1-beta-4",
  "cdr-popover--position": "cdr-popover--position_15-6-1-beta-4",
  "cdr-popover--wrapper": "cdr-popover--wrapper_15-6-1-beta-4",
  "cdr-popover__title": "cdr-popover__title_15-6-1-beta-4",
  "cdr-popover__container": "cdr-popover__container_15-6-1-beta-4",
  "cdr-popover__content": "cdr-popover__content_15-6-1-beta-4",
  "cdr-popover__close-button": "cdr-popover__close-button_15-6-1-beta-4"
};
export {
  t as default
};
